import { Component, OnInit } from '@angular/core';
import {Config} from "../../../../config/config";
import {ActivatedRoute} from "@angular/router";
import {DbModalService} from "../../../../modules/modal/modal";
import {UserSubscription} from "../../../../user/user-subscription";
import {User} from "../../../../user/user";
import {TypeUtils} from "../../../../shared/utils/type-utils";
import {
  OneWeekFreeDemoUpgradeComponent
} from "../../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";
import {Utils} from "../../../../shared/utils/utils";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import {OneMonthFreeComponent} from "../../../../shared/components/dialogs/one-month-free/one-month-free.component";

@Component({
    selector: 'db-ecommerce-menu',
    templateUrl: './ecommerce-menu.component.html',
    styleUrls: ['./ecommerce-menu.component.scss'],
    standalone: false
})
export class EcommerceMenuComponent implements OnInit {
  private _website = this._activatedRoute.snapshot.parent.data['website'];
  isFakeMode = this._website.id === Config.demoDomainId;
  user: User;
  userSubscription: UserSubscription;
  demoUser = false;
  constructor(private _activatedRoute: ActivatedRoute,
              private _googleAnalyticsService: GoogleAnalyticsService,
              private _modalService: DbModalService) { }

  ngOnInit() {
    this.user = this._activatedRoute.snapshot.data['user'];
    this.userSubscription = this._activatedRoute.snapshot.data['subscription'];
    this.demoUser = Utils.isDemoUser(this.userSubscription, this.user);
  }

  public showCheckoutDialog(title): void {
    const analyticsData = {
      eventCategory: 'Free Upgrade Offer',
      eventAction: 'Locked button click',
      eventLabel: title
    };
    if (this.demoUser) {
      const firstTime = TypeUtils.isNull(localStorage.getItem('dbShowFirstTime'));
      const options = {
        overflowHidden: false,
        backdropClass: 'blurred',
      };
      if (!firstTime) {
        options['width'] = 1240;
      } else {
        options['width'] = 460;
        options['height'] = 600;
      }
      const modal = this._modalService.open(OneWeekFreeDemoUpgradeComponent, options);
      modal.componentInstance.showFirstTime = firstTime;
    } else {
      const modal = this._modalService.open(OneMonthFreeComponent, {height: 600, width: 940});
      modal.componentInstance.mode = 'feature';
      modal.componentInstance.showAsDemo = true;
    }
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

}
